import { render, staticRenderFns } from "./site-view-trend-reports-chart.vue?vue&type=template&id=b0f8786c&scoped=true"
import script from "./site-view-trend-reports-chart.vue?vue&type=script&lang=ts"
export * from "./site-view-trend-reports-chart.vue?vue&type=script&lang=ts"
import style0 from "./site-view-trend-reports-chart.vue?vue&type=style&index=0&id=b0f8786c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f8786c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f8786c')) {
      api.createRecord('b0f8786c', component.options)
    } else {
      api.reload('b0f8786c', component.options)
    }
    module.hot.accept("./site-view-trend-reports-chart.vue?vue&type=template&id=b0f8786c&scoped=true", function () {
      api.rerender('b0f8786c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/site-view/sections/site-view-trend-reports-chart.vue"
export default component.exports